<template> 
<DashboardContent />
</template>

<script>
import DashboardContent from './DashboardContent.vue'

  export default {
    components: {
      DashboardContent
    }
  }

</script>
